import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { getEmployeeHistory } from "@/lib/employeeApi";

export const HistoryTab = ({ userId }) => {
  const [rows, setRows] = useState(null);
  useEffect(() => { getEmployeeHistory(userId).then(setRows).catch(() => setRows([])); }, [userId]);
  if (rows === null) return <Loader2 className="w-5 h-5 animate-spin text-teal" />;
  if (rows.length === 0) return <p className="text-sm text-slate-500" data-testid="user-history-empty">No changes recorded yet.</p>;
  return (
    <div className="space-y-3" data-testid="user-history-tab">
      {rows.map((h) => (
        <div key={h.id} className="rounded-lg border border-slate-200" data-testid={`user-history-${h.id}`}>
          <p className="px-3 py-2 text-xs text-slate-500 bg-slate-50 border-b border-slate-100">
            <b className="text-navy">{h.actor_name}</b> · {new Date(h.at).toLocaleString()}
          </p>
          <table className="w-full text-xs table-fixed">
            <colgroup><col className="w-1/3" /><col className="w-1/3" /><col className="w-1/3" /></colgroup>
            <tbody>
              {h.changes.map((c, i) => (
                <tr key={i} className="border-b border-slate-50 last:border-0">
                  <td className="px-3 py-1.5 font-medium text-slate-700 w-1/3">{c.label}</td>
                  <td className="px-3 py-1.5 text-slate-400 line-through">{c.old || "—"}</td>
                  <td className="px-3 py-1.5 text-navy">{c.new || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ))}
    </div>
  );
};
